import { Dialog, DialogContent } from '@nesso/ui/primitives/dialog';

import { EmailVerificationNotice } from '@/widgets/user/email-verification-notice';

type Props = {
    open: boolean;
    email: string | undefined;
    onClose: () => void;
};

export function PlanBillingUpgradeReminderDialog({ open, email, onClose }: Props) {
    return (
        <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
            <DialogContent showCloseButton={false}>
                <EmailVerificationNotice
                    title="Verify your email to complete your upgrade"
                    email={email}
                    onClose={onClose}
                />
            </DialogContent>
        </Dialog>
    );
}
